import store from '@/store'

export default [
  {
    path: '/stock-transfers',
    name: 'stock-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-transfer/index.vue'),
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: '/stock-transfers/create',
    name: 'stock-transfer-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-transfer/create.vue')
  },
  {
    path: '/stock-transfers/:id',
    name: 'stock-transfer-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-transfer/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('stockTransfer/find', to.params.id)
      next()
    }
  },
  {
    path: '/stock-transfers/createv2',
    name: 'stock-transfer-create-v2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock-transfer/create-v2.vue')
  }
]
